(function() {
  const CONFIG = {
    queryParam: 'pv2',
    storageKey: 'um_google_automatic_discount',
    lineItemProperty: '_google_target_price',
    validityMinutes: 30,
    // Keep this intentionally narrow so we only affect PDP pricing.
    pdpPriceSelector: '[data-product-price][data-pdp-main-price], [data-product-price]',
    nativePriceContainerSelector: '.product-block--price, .pdp-price-row__top',
    gmcBlockSelector: '[data-um-gmc-price-block]',
    debugQueryParam: 'gmcdebug'
  };
  let currentVariantPriceCents = null;
  let renderRaf = 0;
  let settleTimer = 0;
  let lastRenderedSignature = '';
  let debugEnabled = false;

  function isPdpPerfOptimized() {
    return window.__PDP_MOBILE_PERF_OPTIMIZED__ === true;
  }

  function getDiscountRenderSignature(discount) {
    const mainPrice = document.querySelector(CONFIG.pdpPriceSelector);
    const stickyPrice = document.querySelector('[js-product="stickyAddToCartPrice"]');
    const ctaPrice = document.querySelector('[data-pdp-atc-selection-price]');
    return [
      discount && discount.price,
      discount && discount.variantId,
      getActiveVariantId(document),
      currentVariantPriceCents,
      mainPrice && mainPrice.innerHTML,
      stickyPrice && stickyPrice.innerHTML,
      ctaPrice && ctaPrice.innerHTML
    ].join('::');
  }

  function now() {
    return Date.now();
  }

  function debugLog(message, data) {
    if (!debugEnabled) return;
    try {
      console.log('[UM GMC]', message, data || '');
    } catch (_) {}
  }

  function isLocalDevHost() {
    const host = window.location && window.location.hostname ? window.location.hostname : '';
    return host === '127.0.0.1' || host === 'localhost' || host === '0.0.0.0';
  }

  function decodeTokenPayload(token) {
    if (!token || token.split('.').length < 2) return null;
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - (base64.length % 4 || 4)) % 4);
      const binary = window.atob(padded);
      const utf8 = decodeURIComponent(Array.prototype.map.call(binary, function(ch) {
        return '%' + ('00' + ch.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(utf8);
    } catch (_) {
      return null;
    }
  }

  function getPvTokenFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      return params.get(CONFIG.queryParam);
    } catch (_) {
      return null;
    }
  }

  function getVariantIdFromPayload(payload) {
    if (!payload) return null;
    const offerKey = payload.o;
    if (typeof offerKey !== 'string' || offerKey.indexOf('_') === -1) return null;
    const parts = offerKey.split('_');
    const last = parts[parts.length - 1];
    if (!last) return null;
    return /^\d+$/.test(last) ? String(last) : null;
  }

  function readStoredDiscount() {
    try {
      const raw = localStorage.getItem(CONFIG.storageKey);
      if (!raw) return null;
      const data = JSON.parse(raw);
      const isExpired = data && data.expiry ? now() > data.expiry : true;
      if (!data || !data.price || (!isLocalDevHost() && isExpired)) {
        localStorage.removeItem(CONFIG.storageKey);
        return null;
      }
      return data;
    } catch (_) {
      return null;
    }
  }

  function persistIncomingDiscount() {
    const token = getPvTokenFromUrl();
    if (!token) return null;
    const payload = decodeTokenPayload(token);
    if (!payload || payload.p == null) return null;

    const payloadVariantId = getVariantIdFromPayload(payload);
    const arrivalVariantId = getVariantIdFromUrl() || payloadVariantId || getSelectedVariantId(document);
    const arrivalVariant = findVariantById(arrivalVariantId, document);
    const originalFromPayload = computeOriginalCentsFromPayload(payload.p, payload.dp);
    const discount = {
      price: String(payload.p),
      discountPercent: typeof payload.dp === 'number' ? payload.dp : null,
      currency: payload.c || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
      expiry: now() + (CONFIG.validityMinutes * 60 * 1000),
      variantId: arrivalVariantId,
      originalPriceCents: originalFromPayload != null
        ? originalFromPayload
        : (arrivalVariant && typeof arrivalVariant.price === 'number' ? arrivalVariant.price : null)
    };

    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
    } catch (_) {}

    return discount;
  }

  function formatMoneyFromCents(cents) {
    const value = Number(cents);
    if (!Number.isFinite(value)) return null;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      const moneyFormat = (window.theme.settings && window.theme.settings.moneyFormat) || undefined;
      return window.theme.Currency.formatMoney(value, moneyFormat);
    }
    return (value / 100).toFixed(2);
  }

  function shouldStripPdpTrailingZeros() {
    const root = document.querySelector('[data-pdp-pricing-experiment]');
    return root && root.dataset && root.dataset.pdpStripTrailingZeros === 'true';
  }

  function formatMoneyDisplayFromCents(cents) {
    const root = document.querySelector('[data-pdp-pricing-experiment]');
    const moneyFormat = root && root.dataset && root.dataset.moneyFormat ? root.dataset.moneyFormat : null;
    const formatted = window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function'
      ? window.theme.Currency.formatMoney(Number(cents), moneyFormat || (window.theme.settings && window.theme.settings.moneyFormat))
      : formatMoneyFromCents(cents);
    if (!shouldStripPdpTrailingZeros()) return formatted;
    return String(formatted)
      .replace(/(\d)[\.,]00(\D|$)/, '$1$2')
      .replace(/<\/sup>\.00(\D|$)/, '</sup>$1');
  }

  function formatDiscountPrice(priceMajor) {
    const numeric = Number(priceMajor);
    if (!Number.isFinite(numeric)) return null;
    return formatMoneyFromCents(Math.round(numeric * 100));
  }

  function normalizeDiscountPercent(dp) {
    const value = Number(dp);
    if (!Number.isFinite(value) || value <= 0) return null;
    return value > 0 && value < 1 ? value * 100 : value;
  }

  function computeOriginalCentsFromPayload(priceMajor, dpRaw) {
    const discountedCents = Math.round(Number(priceMajor) * 100);
    const percent = normalizeDiscountPercent(dpRaw);
    if (!Number.isFinite(discountedCents) || discountedCents <= 0) return null;
    if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return null;
    const originalCents = Math.round(discountedCents / (1 - (percent / 100)));
    return Number.isFinite(originalCents) && originalCents > discountedCents ? originalCents : null;
  }

  function getGoogleCanonicalOriginalCents() {
    try {
      const data = window.automatedDiscountsLiquidData;
      if (!data || data.currentPrice == null) return null;
      const numeric = Number(data.currentPrice);
      if (!Number.isFinite(numeric) || numeric <= 0) return null;
      return Math.round(numeric * 100);
    } catch (_) {
      return null;
    }
  }

  function parseDisplayedMoneyToCents(text) {
    if (!text) return null;
    const stripped = String(text).replace(/[^\d.,]/g, '');
    if (!stripped) return null;
    const normalized = stripped.includes(',') && !stripped.includes('.')
      ? stripped.replace(/\./g, '').replace(',', '.')
      : stripped.replace(/,/g, '');
    const numeric = Number(normalized);
    if (!Number.isFinite(numeric)) return null;
    return Math.round(numeric * 100);
  }

  function resolveVariantPriceFromEmbeddedJson(node) {
    const canUseClosest = !!(node && typeof node.closest === 'function');
    const scope = (canUseClosest && node.closest('section[id^="MainProduct-"], .shopify-section, .product-single, .product')) || document;
    const selectedVariantId = getActiveVariantId(scope);
    const match = findVariantById(selectedVariantId, scope);
    return match && typeof match.price === 'number' && Number.isFinite(match.price) ? match.price : null;
  }

  function findVariantById(variantId, scope) {
    if (!variantId) return null;
    const root = scope || document;
    const variantScripts = root.querySelectorAll('script[data-pdp-pricing-variants]');
    for (let i = 0; i < variantScripts.length; i += 1) {
      try {
        const variants = JSON.parse(variantScripts[i].textContent || '[]');
        if (!Array.isArray(variants)) continue;
        const match = variants.find(function(v) { return String(v && v.id) === String(variantId); });
        if (match) return match;
      } catch (_) {}
    }
    return null;
  }

  function ensureDiscountStyles() {
    if (document.getElementById('um-gmc-price-styles')) return;
    const style = document.createElement('style');
    style.id = 'um-gmc-price-styles';
    style.textContent = [
      '.um-gmc-price-block{margin:3px 0 0;}',
      '.um-gmc-price-block .um-gmc-price-wrap{display:inline;}',
      '.um-gmc-price-block .um-gmc-original,.um-gmc-price-block .um-gmc-discount{font-family:inherit !important;font-size:calc(var(--typeBaseSize) + 6px) !important;line-height:inherit !important;}',
      '.um-gmc-price-block .um-gmc-original{display:inline-block !important;margin-right:8px !important;opacity:.7 !important;font-weight:400 !important;text-decoration:line-through !important;}',
      '.um-gmc-price-block .um-gmc-discount{display:inline-block !important;color:#d32f2f !important;font-weight:700 !important;}',
      '.um-gmc-native-price-hidden{display:none !important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function getSelectedVariantId(scope) {
    const root = scope || document;
    const variantIdInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantIdInput && variantIdInput.value) return String(variantIdInput.value);
    return null;
  }

  function getVariantIdFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const id = params.get('variant');
      return id ? String(id) : null;
    } catch (_) {
      return null;
    }
  }

  function getActiveVariantId(scope) {
    return getSelectedVariantId(scope) || getVariantIdFromUrl();
  }

  function getArrivalVariantId() {
    return getVariantIdFromUrl() || getSelectedVariantId(document);
  }

  function clearDiscountUi() {
    const nativeContainers = document.querySelectorAll(CONFIG.nativePriceContainerSelector);
    nativeContainers.forEach(function(container) {
      if (!(container instanceof HTMLElement)) return;
      container.classList.remove('um-gmc-native-price-hidden');
    });
    const blocks = document.querySelectorAll(CONFIG.gmcBlockSelector);
    blocks.forEach(function(block) {
      if (block && block.parentNode) block.parentNode.removeChild(block);
    });

    const stickyCompare = document.querySelector('[js-product="stickyAddToCartComparePrice"]');
    if (stickyCompare) {
      stickyCompare.classList.add('hidden');
      stickyCompare.textContent = '';
    }

    const ctaCompare = document.querySelector('[data-pdp-atc-selection-compare]');
    if (ctaCompare) {
      ctaCompare.classList.add('hidden');
      ctaCompare.textContent = '';
    }

  }

  function clearStoredDiscount() {
    try {
      localStorage.removeItem(CONFIG.storageKey);
    } catch (_) {}
  }

  function isDiscountVariantActive(discount) {
    if (!discount || !discount.variantId) return true;
    const selectedVariantId = getActiveVariantId(document);
    return !!selectedVariantId && String(selectedVariantId) === String(discount.variantId);
  }

  function resolveOriginalPrice(node, discount) {
    const discountedCents = discount && discount.price != null ? Math.round(Number(discount.price) * 100) : null;
    if (discount && discount.price != null) {
      const fromPayload = computeOriginalCentsFromPayload(discount.price, discount.discountPercent);
      if (fromPayload != null && (!Number.isFinite(discountedCents) || fromPayload > discountedCents)) {
        if (discount.originalPriceCents !== fromPayload) {
          discount.originalPriceCents = fromPayload;
          try {
            localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
          } catch (_) {}
        }
        return formatMoneyFromCents(fromPayload);
      }
    }

    if (discount && discount.variantId) {
      const lockedVariant = findVariantById(discount.variantId, document);
      if (lockedVariant && typeof lockedVariant.price === 'number' && lockedVariant.price > 0 && (!Number.isFinite(discountedCents) || lockedVariant.price > discountedCents)) {
        discount.originalPriceCents = lockedVariant.price;
        try {
          localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
        } catch (_) {}
        return formatMoneyFromCents(lockedVariant.price);
      }
    }

    if (discount && typeof discount.originalPriceCents === 'number' && discount.originalPriceCents > 0 && (!Number.isFinite(discountedCents) || discount.originalPriceCents > discountedCents)) {
      return formatMoneyFromCents(discount.originalPriceCents);
    }

    const canonicalOriginal = getGoogleCanonicalOriginalCents();
    if (canonicalOriginal != null && (!Number.isFinite(discountedCents) || canonicalOriginal > discountedCents)) {
      if (discount && discount.originalPriceCents !== canonicalOriginal) {
        discount.originalPriceCents = canonicalOriginal;
        try {
          localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
        } catch (_) {}
      }
      return formatMoneyFromCents(canonicalOriginal);
    }

    if (currentVariantPriceCents != null) return formatMoneyFromCents(currentVariantPriceCents);
    const embeddedVariantPrice = resolveVariantPriceFromEmbeddedJson(node);
    if (embeddedVariantPrice != null) return formatMoneyFromCents(embeddedVariantPrice);
    const fallbackCents = parseDisplayedMoneyToCents((node.textContent || '').trim());
    if (fallbackCents != null) return formatMoneyFromCents(fallbackCents);
    return (node.textContent || '').trim();
  }

  function getDisplayedCentsFromElement(node) {
    if (!(node instanceof HTMLElement)) return null;
    return parseDisplayedMoneyToCents((node.textContent || '').trim());
  }

  function resolveOriginalPriceCents(discount, fallbackText) {
    const discountedCents = discount && discount.price != null ? Math.round(Number(discount.price) * 100) : null;

    if (discount && discount.price != null) {
      const fromPayload = computeOriginalCentsFromPayload(discount.price, discount.discountPercent);
      if (fromPayload != null && (!Number.isFinite(discountedCents) || fromPayload > discountedCents)) return fromPayload;
    }

    if (discount && discount.variantId) {
      const lockedVariant = findVariantById(discount.variantId, document);
      if (lockedVariant && typeof lockedVariant.price === 'number' && lockedVariant.price > 0 && (!Number.isFinite(discountedCents) || lockedVariant.price > discountedCents)) {
        return lockedVariant.price;
      }
    }

    if (discount && typeof discount.originalPriceCents === 'number' && discount.originalPriceCents > 0 && (!Number.isFinite(discountedCents) || discount.originalPriceCents > discountedCents)) {
      return discount.originalPriceCents;
    }

    const canonicalOriginal = getGoogleCanonicalOriginalCents();
    if (canonicalOriginal != null && (!Number.isFinite(discountedCents) || canonicalOriginal > discountedCents)) return canonicalOriginal;

    return parseDisplayedMoneyToCents(fallbackText || '');
  }

  function pickBestOriginalCents(discountedCents, candidates) {
    const valid = (candidates || []).filter(function(value) {
      return Number.isFinite(value) && value > discountedCents;
    });
    if (!valid.length) return null;
    return Math.max.apply(null, valid);
  }


  function renderDiscountPriceBlock(discount) {
    if (!discount) return;
    if (!isDiscountVariantActive(discount)) {
      clearDiscountUi();
      return;
    }
    const formatted = formatDiscountPrice(discount.price);
    if (!formatted) return;
    const discountedCents = Math.round(Number(discount.price) * 100);
    if (!Number.isFinite(discountedCents) || discountedCents <= 0) {
      clearDiscountUi();
      return;
    }
    ensureDiscountStyles();

    const priceNodes = document.querySelectorAll(CONFIG.pdpPriceSelector);
    const firstPriceNode = priceNodes && priceNodes.length ? priceNodes[0] : null;
    const fallbackOriginalText = resolveOriginalPrice(firstPriceNode, discount);

    priceNodes.forEach(function(node) {
      if (!(node instanceof HTMLElement)) return;
      if (node.closest('.cart, .cart-drawer, .ajaxcart, .cart__drawer')) return;

      const nativeContainer = node.closest(CONFIG.nativePriceContainerSelector) || node;

      const parent = nativeContainer.parentElement;
      if (!parent) return;

      const displayedCents = getDisplayedCentsFromElement(node);
      const fallbackCents = resolveOriginalPriceCents(discount, fallbackOriginalText);
      const lockedVariant = discount && discount.variantId ? findVariantById(discount.variantId, document) : null;
      const lockedVariantPrice = lockedVariant && typeof lockedVariant.price === 'number' ? lockedVariant.price : null;
      const originalCents = pickBestOriginalCents(discountedCents, [displayedCents, fallbackCents, lockedVariantPrice]);
      debugLog('main-price-eval', {
        discountedCents: discountedCents,
        displayedCents: displayedCents,
        fallbackCents: fallbackCents,
        lockedVariantPrice: lockedVariantPrice,
        chosenOriginalCents: originalCents,
        variantId: discount && discount.variantId ? String(discount.variantId) : null
      });
      if (!Number.isFinite(originalCents) || originalCents <= discountedCents) {
        nativeContainer.classList.remove('um-gmc-native-price-hidden');
        const existing = parent.querySelector(CONFIG.gmcBlockSelector);
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      const originalText = formatMoneyDisplayFromCents(originalCents);
      if (!originalText) return;

      const nativeCompareWrap = parent.querySelector('[data-product-price-wrap]');
      const nativeComparePrice = parent.querySelector('[data-compare-price]');
      if (nativeCompareWrap && nativeComparePrice) {
        nativeContainer.classList.remove('um-gmc-native-price-hidden');
        nativeCompareWrap.classList.remove('hide');
        nativeComparePrice.innerHTML = originalText;
        node.classList.add('on-sale');
        node.innerHTML = formatMoneyDisplayFromCents(discountedCents);

        const existing = parent.querySelector(CONFIG.gmcBlockSelector);
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }

      nativeContainer.classList.add('um-gmc-native-price-hidden');
      let block = parent.querySelector(CONFIG.gmcBlockSelector);
      if (!block) {
        block = document.createElement('div');
        block.setAttribute('data-um-gmc-price-block', 'true');
        block.className = 'um-gmc-price-block';
        nativeContainer.insertAdjacentElement('afterend', block);
      }

      block.innerHTML =
        '<span class="um-gmc-price-wrap">' +
          '<s class="um-gmc-original" data-um-gmc-original>' + originalText + '</s>' +
        '</span>' +
        '<span class="um-gmc-discount" data-um-gmc-discount>' + formatMoneyDisplayFromCents(discountedCents) + '</span>';
    });


    const stickyPrice = document.querySelector('[js-product="stickyAddToCartPrice"]');
    const stickyCompare = document.querySelector('[js-product="stickyAddToCartComparePrice"]');
    let stickyChosenBaseCents = null;
    if (stickyPrice) {
      const stickyOriginalCents = getDisplayedCentsFromElement(stickyPrice);
      const stickyFallbackCents = resolveOriginalPriceCents(discount, stickyPrice.textContent || '');
      const stickyBaseCents = pickBestOriginalCents(discountedCents, [stickyOriginalCents, stickyFallbackCents]);
      debugLog('sticky-price-eval', {
        discountedCents: discountedCents,
        stickyOriginalCents: stickyOriginalCents,
        stickyFallbackCents: stickyFallbackCents,
        stickyBaseCents: stickyBaseCents
      });
      if (Number.isFinite(stickyBaseCents) && stickyBaseCents > discountedCents) {
        stickyChosenBaseCents = stickyBaseCents;
        stickyPrice.innerHTML = formatMoneyDisplayFromCents(discountedCents);
        if (stickyCompare) {
          stickyCompare.classList.remove('hidden');
          stickyCompare.innerHTML = formatMoneyDisplayFromCents(stickyBaseCents) || '';
          stickyCompare.style.display = '';
          stickyCompare.setAttribute('aria-hidden', 'false');
        }
      }
    }

    const ctaPrice = document.querySelector('[data-pdp-atc-selection-price]');
    const ctaCompare = document.querySelector('[data-pdp-atc-selection-compare]');
    let ctaChosenBaseCents = null;
    if (ctaPrice) {
      const ctaOriginalCents = getDisplayedCentsFromElement(ctaPrice);
      const ctaFallbackCents = resolveOriginalPriceCents(discount, ctaPrice.textContent || '');
      const ctaBaseCents = pickBestOriginalCents(discountedCents, [ctaOriginalCents, ctaFallbackCents]);
      debugLog('cta-price-eval', {
        discountedCents: discountedCents,
        ctaOriginalCents: ctaOriginalCents,
        ctaFallbackCents: ctaFallbackCents,
        ctaBaseCents: ctaBaseCents
      });
      if (Number.isFinite(ctaBaseCents) && ctaBaseCents > discountedCents) {
        ctaChosenBaseCents = ctaBaseCents;
        ctaPrice.innerHTML = formatMoneyDisplayFromCents(discountedCents);
        if (ctaCompare) {
          ctaCompare.classList.remove('hidden');
          ctaCompare.innerHTML = formatMoneyDisplayFromCents(ctaBaseCents) || '';
          ctaCompare.style.display = '';
          ctaCompare.setAttribute('aria-hidden', 'false');
        }
      }
    }
  }

  function installFetchInterceptor() {
    if (window.__umGmcFetchPatched) return;
    window.__umGmcFetchPatched = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function(resource, init) {
      const discount = readStoredDiscount();
      if (!discount || !discount.price || !isDiscountVariantActive(discount)) {
        return originalFetch.apply(this, arguments);
      }

      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        return originalFetch.apply(this, arguments);
      }

      try {
        const nextInit = Object.assign({}, init || {});
        const body = nextInit.body;
        const propertyName = 'properties[' + CONFIG.lineItemProperty + ']';
        const propertyValue = String(discount.price);

        if (body instanceof FormData) {
          body.set(propertyName, propertyValue);
        } else if (body instanceof URLSearchParams) {
          body.set(propertyName, propertyValue);
        } else if (typeof body === 'string') {
          const trimmed = body.trim();
          if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
            try {
              const json = JSON.parse(body);
              if (Array.isArray(json.items)) {
                json.items.forEach(function(item) {
                  item.properties = item.properties || {};
                  item.properties[CONFIG.lineItemProperty] = propertyValue;
                });
              } else {
                json.properties = json.properties || {};
                json.properties[CONFIG.lineItemProperty] = propertyValue;
              }
              nextInit.body = JSON.stringify(json);
            } catch (_) {}
          } else {
            const params = new URLSearchParams(body);
            params.set(propertyName, propertyValue);
            nextInit.body = params.toString();
          }
        }

        return originalFetch.call(this, resource, nextInit);
      } catch (_) {
        return originalFetch.apply(this, arguments);
      }
    };
  }

  function init() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      debugEnabled = params.get(CONFIG.debugQueryParam) === '1' || window.__UM_GMC_DEBUG__ === true;
    } catch (_) {
      debugEnabled = window.__UM_GMC_DEBUG__ === true;
    }

    const fromUrl = persistIncomingDiscount();
    const discount = fromUrl || readStoredDiscount();
    debugLog('init-discount', discount);
    if (discount && !discount.variantId) {
      discount.variantId = getVariantIdFromUrl() || getSelectedVariantId(document) || getArrivalVariantId();
    }
    if (discount && discount.variantId && (discount.originalPriceCents == null || !Number.isFinite(Number(discount.originalPriceCents)) || Number(discount.originalPriceCents) <= 0)) {
      const arrivalVariant = findVariantById(discount.variantId, document);
      if (arrivalVariant && typeof arrivalVariant.price === 'number') {
        discount.originalPriceCents = arrivalVariant.price;
        try {
          localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
        } catch (_) {}
      }
    }
    const rerender = function() {
      if (renderRaf) cancelAnimationFrame(renderRaf);
      renderRaf = requestAnimationFrame(function() {
        renderRaf = 0;
        const liveDiscount = readStoredDiscount();
        if (!liveDiscount) {
          clearDiscountUi();
          lastRenderedSignature = '';
          return;
        }
        if (isPdpPerfOptimized()) {
          const beforeSignature = getDiscountRenderSignature(liveDiscount);
          if (beforeSignature === lastRenderedSignature) return;
          renderDiscountPriceBlock(liveDiscount);
          lastRenderedSignature = getDiscountRenderSignature(liveDiscount);
          return;
        }
        renderDiscountPriceBlock(liveDiscount);
      });
    };
    const rerenderWithSettle = function() {
      rerender();
      if (!isPdpPerfOptimized()) return;
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function() {
        settleTimer = 0;
        rerender();
      }, 160);
    };
    if (discount) {
      currentVariantPriceCents = resolveVariantPriceFromEmbeddedJson(document);
      if (isPdpPerfOptimized()) {
        rerenderWithSettle();
      } else {
        renderDiscountPriceBlock(discount);
        setTimeout(function() {
          renderDiscountPriceBlock(readStoredDiscount());
        }, 50);
        setTimeout(function() {
          renderDiscountPriceBlock(readStoredDiscount());
        }, 250);
        setTimeout(function() {
          renderDiscountPriceBlock(readStoredDiscount());
        }, 900);
      }
    } else {
      clearDiscountUi();
    }
    installFetchInterceptor();

    if (!discount) return;
    document.addEventListener('variant:change', function(event) {
      if (!readStoredDiscount()) return;
      const price = event && event.detail && event.detail.variant && event.detail.variant.price;
      if (typeof price === 'number' && Number.isFinite(price)) {
        currentVariantPriceCents = price;
      }
      if (isPdpPerfOptimized()) rerenderWithSettle();
      else {
        setTimeout(rerender, 0);
        rerender();
      }
    });
    document.addEventListener('theme:variant:change', function(event) {
      if (!readStoredDiscount()) return;
      const price = event && event.detail && event.detail.variant && event.detail.variant.price;
      if (typeof price === 'number' && Number.isFinite(price)) {
        currentVariantPriceCents = price;
      }
      if (isPdpPerfOptimized()) rerenderWithSettle();
      else {
        setTimeout(rerender, 0);
        rerender();
      }
    });

    document.addEventListener('change', function(event) {
      const target = event && event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== 'id') return;
      if (isPdpPerfOptimized()) rerenderWithSettle();
      else {
        setTimeout(rerender, 0);
        rerender();
      }
    }, true);

    document.addEventListener('pdp:pricing-updated', function() {
      if (isPdpPerfOptimized()) {
        rerenderWithSettle();
        return;
      }
      setTimeout(rerender, 0);
      setTimeout(rerender, 60);
      setTimeout(rerender, 180);
    });

    document.addEventListener('default-variant-set', function() {
      if (isPdpPerfOptimized()) {
        rerenderWithSettle();
        return;
      }
      setTimeout(rerender, 0);
      setTimeout(rerender, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
